import axios from "axios"
const API_URL = process.env.REACT_APP_API_URL
const login = (email, password) => {
    return axios
        .post(`${API_URL}/auth/login`, {
            email,
            password,
        })
        .then(response => {
            if (response.status === 200) {
                const { data } = response.data
                localStorage.setItem("apiToken", data.token)
                localStorage.setItem("userInfo", JSON.stringify(data.userInfo))
                localStorage.setItem("userPermissions", JSON.stringify(data.userInfo.permissions))
            }
            return response
        })
        .catch(error => {
            return error.response
        })
}

const logout = () => {
    localStorage.removeItem("apiToken")
    localStorage.removeItem("userInfo")
    localStorage.removeItem("userPermissions")
}

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("userInfo"))
}

const getCurrentUserPermissions = () => {
    return JSON.parse(localStorage.getItem("userPermissions"))
}

const getCurrentToken = () => {
    return localStorage.getItem("apiToken")
}

const isLoggedIn = () => {
    if (getCurrentToken()) {
        return true
    }
    return false
}

export default {
    login,
    logout,
    isLoggedIn,
    getCurrentUser,
    getCurrentUserPermissions
};